const ENC_PREFIX = 'enc:v1:';

const DEFAULT_KEY = 'Y0lJRV9Qb3J0YWxfRGVmYXVsdF9LZXlfMjAyNg==';
const KEY_BASE64 = process.env.VUE_APP_STORAGE_KEY || DEFAULT_KEY;

function getKeyBytes() {
  const binary = atob(KEY_BASE64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

const KEY_BYTES = getKeyBytes();

function xorTransform(inputBytes) {
  const output = new Uint8Array(inputBytes.length);
  for (let i = 0; i < inputBytes.length; i++) {
    output[i] = inputBytes[i] ^ KEY_BYTES[i % KEY_BYTES.length];
  }
  return output;
}

export function encrypt(plaintext) {
  const encoder = new TextEncoder();
  const plaintextBytes = encoder.encode(plaintext);
  const xored = xorTransform(plaintextBytes);
  const binary = String.fromCharCode(...xored);
  return ENC_PREFIX + btoa(binary);
}

export function decrypt(ciphertext) {
  const encoded = ciphertext.slice(ENC_PREFIX.length);
  const binary = atob(encoded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  const decrypted = xorTransform(bytes);
  const decoder = new TextDecoder();
  return decoder.decode(decrypted);
}

export function isEncrypted(value) {
  return typeof value === 'string' && value.startsWith(ENC_PREFIX);
}
